/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgUnderCover32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        d='M21.25 23.25h-8v-1.5h8v1.5zM9.5 24a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM26 22.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM18.53 16.03l2-2-1.06-1.06-2 2 1.06 1.06z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M.25 4A3.75 3.75 0 014 .25h27.75V2A2.75 2.75 0 0129 4.75H1.75v25.5H7.2c-.127-.22-.2-.477-.2-.75v-1.938A2.75 2.75 0 015.25 25v-5A2.75 2.75 0 018 17.25h.6l.662-4.639a2.75 2.75 0 012.723-2.361h10.53a2.75 2.75 0 012.723 2.361l.663 4.639H26A2.75 2.75 0 0128.75 20v5A2.751 2.751 0 0127 27.563V29.5c0 .273-.073.53-.2.75H32v1.5H.25V4zM24.2 30.25c-.127-.22-.2-.477-.2-.75v-1.75H10v1.75c0 .273-.073.53-.2.75h14.4zm-22.322-27H29c.69 0 1.25-.56 1.25-1.25v-.25H4a2.25 2.25 0 00-2.122 1.5zM26 18.75H8c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h18c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25zm-1.615-1.5l-.632-4.427a1.25 1.25 0 00-1.238-1.073h-3.704l-4.28 4.28-1.061-1.06 3.22-3.22h-4.705a1.25 1.25 0 00-1.238 1.073l-.632 4.427h14.27z'
      />
    </svg>
  );
}

export default SvgUnderCover32;
